import React from 'react';
import './InfrastructureHero.css';

const InfrastructureHero = () => {
  return (
    <section className="infrastructure-hero">
      <div className='infrastructure-hero-overlay'></div>
      <div className="infrastructure-hero-wrapper">
        <h1>Infrastructure Development</h1>
        <p>Building a stronger, more connected Igboeze North through impactful infrastructure projects.</p>
      </div>
    </section>
  );
};

export default InfrastructureHero;